module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "article-wrap"
  }, [_c('div', {
    staticClass: "article"
  }, [_c('section', {
    staticClass: "article__section"
  }, [_c('h1', {
    staticClass: "article__header",
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }), (_vm.mediaItems.length) ? _c('div', {
    staticClass: "article__slider"
  }, [(_vm.hasPrevSlide) ? _c('button', {
    staticClass: "article__slider-button",
    attrs: {
      "type": "button",
      "aria-label": "Предыдущий слайд"
    },
    on: {
      "click": _vm.setPrevSlide
    }
  }, [_vm._v("<")]) : _vm._e(), _vm._l((_vm.mediaItems), function(item, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.currentSlide === index),
        expression: "currentSlide === index"
      }],
      key: item.key,
      staticClass: "article__slide"
    }, [(item.type === "image") ? _c('img', {
      staticClass: "article__img",
      attrs: {
        "src": item.src,
        "alt": _vm.title
      }
    }) : _c('div', {
      staticClass: "article__video",
      staticStyle: {
        "height": "466px"
      },
      domProps: {
        "innerHTML": _vm._s(item.html)
      }
    })])
  }), (_vm.hasNextSlide) ? _c('button', {
    staticClass: "article__slider-button article__slider-button_next",
    attrs: {
      "type": "button",
      "aria-label": "Следующий слайд"
    },
    on: {
      "click": _vm.setNextSlide
    }
  }, [_vm._v(">")]) : _vm._e(), (_vm.mediaItems.length > 1) ? _c('div', {
    staticClass: "article__slider-dots"
  }, _vm._l((_vm.mediaItems), function(item, index) {
    return _c('button', {
      key: item.key + "-dot",
      staticClass: "article__slider-dot",
      class: {
        "article__slider-dot_active": _vm.currentSlide === index
      },
      attrs: {
        "type": "button",
        "aria-label": "Показать слайд " + (index + 1)
      },
      on: {
        "click": function($event) {
          return _vm.setSlide(index)
        }
      }
    })
  }), 0) : _vm._e()], 2) : _vm._e(), _c('p', {
    staticClass: "event_type"
  }, [_vm._v(_vm._s(_vm.getEventType))]), _c('div', {
    staticClass: "article__text",
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  }), (_vm.cop_multi_name) ? _c('div', {
    staticClass: "multi_cop"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Партнер ЦОПП: ")]), _vm._v(_vm._s(_vm.cop_multi_name))]) : _vm._e()]), _c('section', [(_vm.$slots.articleReview) ? _c('div', {
    staticClass: "article-review"
  }, [_vm._t("articleReview")], 2) : _vm._e(), _c('div', {
    staticClass: "article-share"
  }, [_c('Share')], 1)])]), _c('div', {
    staticClass: "article-footer"
  }, [_c('div', {
    staticClass: "article-footer-info"
  }, [_c('div', {
    staticClass: "article-footer-col"
  }, [_c('div', {
    staticClass: "article-footer-view"
  }, [_vm._v(_vm._s(_vm.view))])]), _c('div', {
    staticClass: "article-footer-col"
  }, [_c('div', {
    staticClass: "article-footer-comments"
  }, [_vm._v(_vm._s(_vm.comments))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ca9a37e","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/blog/article/Article.vue
// module id = 1640ab67736624491d69
// module chunks = 17